export default __webpack_public_path__ + "static/bride0-e86137504c50618413635c68d01bb3c0.png";